import { BuildingLibraryIcon } from '@heroicons/react/24/outline';
import { GQLPaymentMethodType, GQLSupplementaryPaymentMethodType, GQLVaultedCardTypeType } from '@theprintbar/graphql';
import { ComponentProps } from 'react';
import { AfterpayLongIcon, CreditCardProviderIcon, PaypalIcon, ZipPayLongIcon } from '..';
import { ApplePayIcon } from '../ApplePay';
import { GooglePayIcon } from '../GooglePay';

interface PaymentMethodIconProps extends ComponentProps<'svg'> {
	paymentMethod: GQLPaymentMethodType | GQLSupplementaryPaymentMethodType;
	cardType?: GQLVaultedCardTypeType;
}

export function PaymentMethodIcon({ paymentMethod, cardType, ...iconProps }: PaymentMethodIconProps) {
	switch (paymentMethod) {
		case GQLSupplementaryPaymentMethodType.Card:
		case GQLPaymentMethodType.Card:
			return <CreditCardProviderIcon cardType={cardType} {...iconProps} />;
		case GQLSupplementaryPaymentMethodType.Googlepay:
		case GQLPaymentMethodType.Googlepay:
			return <GooglePayIcon {...iconProps} />;
		case GQLSupplementaryPaymentMethodType.Applepay:
		case GQLPaymentMethodType.Applepay:
			return <ApplePayIcon {...iconProps} />;
		case GQLSupplementaryPaymentMethodType.Paypal:
		case GQLPaymentMethodType.Paypal:
			return <PaypalIcon {...iconProps} />;
		case GQLSupplementaryPaymentMethodType.Afterpay:
		case GQLPaymentMethodType.Afterpay:
			return <AfterpayLongIcon {...iconProps} />;
		case GQLSupplementaryPaymentMethodType.Zip:
		case GQLPaymentMethodType.Zip:
			return <ZipPayLongIcon {...iconProps} />;
		default:
			return <BuildingLibraryIcon {...iconProps} />;
	}
}
